import { useQuery } from '@tanstack/react-query';
import {
  serveCommodities,
  serveOverview,
  serveFobPricePulse,
  serveTerminalPricePulse,
  serveVolumeByOrigin,
  serveSupplyOptions,
  serveWeatherAlerts,
  serveArrivingNext10d,
  serveProducingRegionsScorecards,
} from '../analyticsServeApi';

export const useServeCommodities = () =>
  useQuery({
    queryKey: ['analytics-serve', 'commodities'],
    queryFn: () => serveCommodities(),
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

export const useServeOverview = (commodityKey, opts = {}) => {
  const { email, dateStart, dateEnd } = opts;
  return useQuery({
    queryKey: [
      'analytics-serve',
      'overview',
      commodityKey,
      email ?? null,
      dateStart ?? null,
      dateEnd ?? null,
    ],
    queryFn: ({ signal }) =>
      serveOverview(commodityKey, { signal, email, dateStart, dateEnd }),
    enabled: !!commodityKey,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useServeFobPricePulse = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'fob_price_pulse', commodityKey],
    queryFn: () => serveFobPricePulse(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeTerminalPricePulse = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'terminal_price_pulse', commodityKey],
    queryFn: () => serveTerminalPricePulse(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeVolumeByOrigin = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'volume_by_origin', commodityKey],
    queryFn: () => serveVolumeByOrigin(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeSupplyOptions = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'supply_options', commodityKey],
    queryFn: () => serveSupplyOptions(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeWeatherAlerts = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'weather_alerts', commodityKey],
    queryFn: () => serveWeatherAlerts(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeArrivingNext10d = (commodityKey) =>
  useQuery({
    queryKey: ['analytics-serve', 'arriving_next_10d', commodityKey],
    queryFn: () => serveArrivingNext10d(commodityKey),
    enabled: !!commodityKey,
    staleTime: 5 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
  });

export const useServeProducingRegionsScorecards = (commodityKey, opts = {}) => {
  const { email, dateStart, dateEnd } = opts;
  return useQuery({
    queryKey: [
      'analytics-serve',
      'producing_regions_score_cards',
      commodityKey,
      email ?? null,
      dateStart ?? null,
      dateEnd ?? null,
    ],
    queryFn: ({ signal }) =>
      serveProducingRegionsScorecards(commodityKey, { signal, email, dateStart, dateEnd }),
    enabled: !!commodityKey,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

